import { Button } from "reactstrap";

export default function TrashDeleteBtn() {
    return (
        <Button >
            <i className="fa fa-trash"/>
        </Button>
    )
};